import {
  Clock,
  CheckCircle,
  DollarSign,
  FileText,
  Home,
  Icon,
  Package,
  Plus,
  Settings,
  Users,
  X,
  CreditCard
} from "react-feather";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/storeConfig/store";

type Services = 'empresas' | 'entregas';

interface GetMenuItems {
  isAdmin: boolean;
  service: Services;
}

interface Response {
  isVisible?: boolean;
  to?: string;
  title: string;
  icon: Icon;
  items?: {
    to: boolean | string;
    title: string;
  }[]
}

const today = new Date();
const month = (today.getMonth() + 1).toString().padStart(2, '0');
const year = today.getFullYear().toString();
const page = '1';
const queryParams = new URLSearchParams();
queryParams.append('month', month);
queryParams.append('year', year);
queryParams.append('page', page);
const pageParams = new URLSearchParams();
pageParams.append('page', page);

export function getMenuItems({isAdmin, service}: GetMenuItems): Response[] { 
  const { paymentInCash, activePlan } = useSelector((state: RootState) => state.company);
  
  switch(service) {
    case "empresas": return [
      {
        isVisible: true,
        to: '/dashboard',
        title: 'Página inicial',
        icon: Home,
      },
      {
        isVisible: true,
        to: '/contributors',
        title: 'Colaboradores',
        icon: Users,
      },
      {
        isVisible: true,
        title: 'Configurações',
        icon: Settings,
        items: [
          {
            to: isAdmin && '/costCenter',
            title: 'Centro de custo',
          },
          {
            to: isAdmin && '/company',
            title: 'Empresa',
          }
        ]
      },
      {
        isVisible: true,
        to: '/reports/travelsReport',
        icon: FileText,
        title: 'Relatórios'
      },
    ];

    case "entregas": return [
      {
        isVisible: true,
        to: '/new-order',
        title: 'Nova entrega',
        icon: Plus,
      },
      {
        isVisible: true,
        to: `/track-orders?${pageParams.toString()}`,
        title: 'Acompanhar entregas',
        icon: Package,
      },
      {
        isVisible: true,
        to: '/scheduled-orders',
        title: 'Entregas agendadas',
        icon: Clock,
      },
      {
        isVisible: true,
        to: `/order-history?${queryParams.toString()}`,
        title: 'Entregas realizadas',
        icon: CheckCircle,
      },
      {
        isVisible: true,
        to: '/canceled-orders',
        title: 'Entregas canceladas',
        icon: X,
      },
      {
        isVisible: true,
        title: 'Financeiro',
        icon: DollarSign,
        items: [
          {
            to: '/financial-history',
            title: 'Histórico',
          },
          {
            to: '/payment-history',
            title: 'Pagamentos',
          },
          {
            to: '/delivery-reports', 
            title: 'Relatórios de entregas',
          }
        ]
      },
      {
        isVisible: activePlan === 'pre_paid_plan',
        to: '/wallet',
        title: 'Carteira',
        icon: CreditCard,
      },
      {
        isVisible: paymentInCash !== undefined,
        to: '/settings',
        title: 'Configurações',
        icon: Settings,
      },
    ];
  }
}
